import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  order: null,
  graphStats: null,
};

export const OrderSlice = createSlice({
  name: "OrderSlice",
  initialState,
  reducers: {
    setOrder: (state, { payload }) => {
      state.order = payload;
    },
    setGraphStatsOrders: (state, { payload }) => {
      state.graphStats = payload;
    },
  },
});

export const { setOrder, setGraphStatsOrders } = OrderSlice.actions;
export default OrderSlice.reducer;
